import type { FulfillSuccess } from "@b2bportal/purchase-api";
import { ParentState } from "@hopper-b2b/checkout";
import dayjs from "dayjs";
import type { DoneInvokeEvent } from "xstate";
import type { ActivitiesMachineContext } from "../types";
import { getFulfilledActivityConfirmationId } from "@/utilities/tracking/fulfilledConfirmationId";

export const getCompleteBuyActivityAdditionalProperties = (
  context: ActivitiesMachineContext,
  event?: DoneInvokeEvent<FulfillSuccess>
): Record<string, string | number | boolean | undefined> => {
  const prepareFulfillmentData =
    context[ParentState.activitiesShop]?.prepareFulfillmentData;

  const startDate = prepareFulfillmentData?.startDate;

  // Points (rewards denomination, not cash equivalent)
  const pointsValue =
    context[ParentState.awardsPayment]?.rewardsAmountToApply?.value;

  return {
    confirmation_id: getFulfilledActivityConfirmationId(event),
    lob: "activity",
    advance: startDate ? dayjs(startDate).diff(dayjs(), "day") : undefined,
    departure_date: startDate,
    pax_total: prepareFulfillmentData?.numberOfTravelers,
    searched_pax_total: prepareFulfillmentData?.numberOfTravelers,
    is_agent_session: false,
    total_points_amount: pointsValue,
    additional_points_purchase: pointsValue ? true : undefined,
    additional_points_purchase_total: pointsValue,
    // RBC-2641: offer attribution on all complete_buy events.
    // No offers on activities yet; send 0 so a blank means a bug.
    offer_value_cad: 0,
  };
};
